var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2809",
    "data-name": "Group 2809",
    transform: "translate(5170 23500)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scanning",
    transform: "translate(-5662 -23752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M.75,8.5A.755.755,0,0,1,0,7.75V5.25A5.256,5.256,0,0,1,5.25,0h2.5A.755.755,0,0,1,8.5.75a.755.755,0,0,1-.75.75H5.25A3.751,3.751,0,0,0,1.5,5.25v2.5A.755.755,0,0,1,.75,8.5Z",
    transform: "translate(493.25 253.25)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M7.75,8.5A.755.755,0,0,1,7,7.75V5.25A3.751,3.751,0,0,0,3.25,1.5H.75A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0h2.5A5.256,5.256,0,0,1,8.5,5.25v2.5A.755.755,0,0,1,7.75,8.5Z",
    transform: "translate(506.25 253.25)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M2.25,7.5H.75A.75.75,0,0,1,.75,6h1.5A3.751,3.751,0,0,0,6,2.25V.75a.75.75,0,0,1,1.5,0v1.5A5.256,5.256,0,0,1,2.25,7.5Z",
    transform: "translate(507.25 267.25)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M7.75,8.5H5.25A5.256,5.256,0,0,1,0,3.25V.75A.755.755,0,0,1,.75,0,.755.755,0,0,1,1.5.75v2.5A3.751,3.751,0,0,0,5.25,7h2.5a.75.75,0,0,1,0,1.5Z",
    transform: "translate(493.25 266.25)",
    fill: "#061133"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(492 252)",
    fill: "none",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_eye",
    "data-name": "vuesax/linear/eye",
    transform: "translate(-5273.365 -23683.629)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(108 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M4.473,2.237A2.237,2.237,0,1,1,2.237,0,2.234,2.234,0,0,1,4.473,2.237Z",
    transform: "translate(5.26 5.26)",
    fill: "none",
    stroke: "#061133",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M6.113,10.34A6.883,6.883,0,0,0,11.8,6.791a3.327,3.327,0,0,0,0-3.243A6.883,6.883,0,0,0,6.113,0,6.883,6.883,0,0,0,.422,3.549a3.327,3.327,0,0,0,0,3.243A6.883,6.883,0,0,0,6.113,10.34Z",
    transform: "translate(1.384 2.324)",
    fill: "none",
    stroke: "#061133",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-8",
    "data-name": "Vector",
    d: "M0,0H14.994V14.994H0Z",
    transform: "translate(14.994 14.994) rotate(180)",
    fill: "none",
    opacity: 0
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.aff42f8935fff0dcf8aef5f0d0f010ba.svg";
export { ForwardRef as ReactComponent };